import React from 'react';

import {OrgAndTimer} from '../orgAndTimer/OrgAndTimer';
import {Weather} from '../weather/Weather';
import { trackGoogleEvent } from '../../utils/googleEvents';
import {styles} from './styles';

export const EventInfo = ({ event = {}, fetching = false, style = {}, t }) => {
  const siteLink = event.siteUri ? (
    <div className='siteUri' style={styles.eventContainer}>
      <div style={styles.eventTitle} className={'elp-site-uri'}>
        {t('Official Website')}
      </div>
      <a
        href={event.siteUri}
        target='_blank'
        style={styles.siteLink}
        onClick={() => trackGoogleEvent('Advertisements', 'Click', 'Official Website')}
        className={'elp-site-uri'}
        id={'elp-site-uri-link'}>
        {event.siteUri}
      </a>

      <div style={styles.loadingContainer(fetching)}>
        <div style={styles.loadingTitle}/>
        <div style={styles.loadingDetail}/>
      </div>
    </div>
  ) : null;

  return (
    <div className="row">
      <div className="col-12 col-md-6 col-lg-12">
      {(event.location || {}).latitude ?
        <Weather event={event} style={style}/> : null
      }
      </div>
      <div className="col-12 col-md-6 col-lg-12">
      {siteLink}
      <OrgAndTimer event={event} fetching={fetching} t={t} />
      </div>
      <div className="col-12 col-md-6 col-lg-12" style={styles.eventContainer}>
        { (event.facebookUrl !== null || event.twitterHandle !== null) &&
          <div style={styles.eventTitle}>{t('Event Links')}</div>
        }
        { event.facebookUrl !== null &&
          <a href={event.facebookUrl} target='_blank' style={styles.link}>
            Facebook
          </a>
        }
        { event.twitterHandle !== null &&
          <a href={event.twitterHandle} target='_blank' style={styles.link}>
            Twitter
          </a>
        }
        { event.instagramHandle !== null &&
        <a href={event.instagramHandle} target='_blank' style={styles.link}>
          Instagram
        </a>
        }
      </div>
    </div>
  );
};



/** WEBPACK FOOTER **
 ** ./components/eventInfo/EventInfo.js
 **/